import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import ContentItem4 from 'presentations/views/components/molecules/ServiceContentItem4';
import Button from 'presentations/views/components/atoms/Button';
import {
  productIntegrationPath,
  productIntegrationsPath,
} from 'presentations/routes/path';
import { IntegrationType } from 'domains/models/account/providerType';

interface Props {
  title?: string;
  titleEn?: string;
  description?: string;
  isShowMore?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle
        title={props.title || t('title')}
        description={props.description || t('description')}
      />
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/googlecalendar.svg"
            imageWidth={72}
            imageHeight={72}
            title={t('item 8 title')}
            description={t('item 8 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/outlook.svg"
            imageWidth={60}
            imageHeight={60}
            title={t('item 9 title')}
            description={t('item 9 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/integrations/apple.svg"
            imageWidth={47}
            imageHeight={53}
            title={t('item 15 title')}
            description={t('item 15 description')}
          />
        </ListItem>
      </ListContainer2>
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/zoom.svg"
            imageWidth={60}
            imageHeight={60}
            title={t('item 1 title')}
            description={t('item 1 description')}
            link={productIntegrationPath(IntegrationType.Zoom)}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/googlemeet.svg"
            imageWidth={70}
            imageHeight={58}
            title={t('item 5 title')}
            description={t('item 5 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/teams.svg"
            imageWidth={63}
            imageHeight={58}
            title={t('item 6 title')}
            description={t('item 6 description')}
          />
        </ListItem>
      </ListContainer2>
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/slack.svg"
            imageWidth={60}
            imageHeight={60}
            title={t('item 2 title')}
            description={t('item 2 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/notion.svg"
            imageWidth={60}
            imageHeight={60}
            title={t('item 12 title')}
            description={t('item 12 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/googlesheet.svg"
            imageWidth={72}
            imageHeight={72}
            title={t('item 13 title')}
            description={t('item 13 description')}
          />
        </ListItem>
      </ListContainer2>
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/salesforce.svg"
            imageWidth={76}
            imageHeight={54}
            title={t('item 7 title')}
            description={t('item 7 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/hubspot.svg"
            imageWidth={76}
            imageHeight={75}
            link={productIntegrationPath(IntegrationType.HubSpot)}
            title={t('item 11 title')}
            description={t('item 11 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="integrations/stripe.svg"
            imageWidth={77}
            imageHeight={32}
            title={t('item 4 title')}
            description={t('item 4 description')}
          />
        </ListItem>
      </ListContainer2>
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/integrations/google_analytics.svg"
            imageWidth={72}
            imageHeight={72}
            title={t('item 16 title')}
            description={t('item 16 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/meta.svg"
            imageWidth={144}
            imageHeight={72}
            title={t('item 14 title')}
            description={t('item 14 description')}
          />
        </ListItem>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/sms.svg"
            imageWidth={72}
            imageHeight={72}
            title={t('item 10 title')}
            description={t('item 10 description')}
          />
        </ListItem>
      </ListContainer2>
      <ListContainer2>
        <ListItem>
          <ContentItem4
            imageUrl="pages/top/integration/email.svg"
            imageWidth={60}
            imageHeight={60}
            title={t('item 3 title')}
            description={t('item 3 description')}
          />
        </ListItem>
      </ListContainer2>
      {props.isShowMore && (
        <More>
          <Button color="primary" size="large" href={productIntegrationsPath()}>
            {t('more')}
          </Button>
        </More>
      )}
    </>
  );
}

const ListContainer2 = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: stretch;
  margin-bottom: ${spacing(24)};
  :last-of-type {
    margin-bottom: 0;
  }
  ${mediaMax.tablet} {
    display: block;
  }
`;

const ListItem = styled.div`
  width: 32%;
  height: auto;
  margin-right: ${spacing(16)};
  :last-of-type {
    margin-right: 0;
  }
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(24)};
  }
`;

const More = styled.div`
  margin-top: ${spacing(32)};
  text-align: center;
`;
